function readCookies() {
    try {
        return document.cookie.split(";");
    }
    catch (_a) {
        // No access to cookies
        return [];
    }
}
export function getCookies(name) {
    const cookies = [];
    for (const cookie of readCookies()) {
        const [key, value] = cookie.trim().split("=");
        if (name === key && value !== undefined) {
            cookies.push({ key, value });
        }
    }
    return cookies;
}
export function deleteCookie(name) {
    const { domain } = document;
    const time = Date.now();
    const expiration = new Date(time - 1).toUTCString();
    const expires = `; expires=${expiration}`;
    const secure = globalThis.location.protocol === "https:" ? "; secure" : "";
    try {
        // eslint-disable-next-line unicorn/no-document-cookie
        document.cookie = `${name}=; path=/; domain=${domain}${expires}${secure}`;
    }
    catch (_a) {
        // No access to cookies
    }
}
